import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const YouTubeApp = () => {

  const history = useNavigate();

  useEffect(() => {
    const redirectTimeout = setTimeout(() => {
      window.location.href = 'https://www.youtube.com/@lunaticproject';
    }, 0);

    return () => clearTimeout(redirectTimeout);
  }, [history]);

  return (<></>);
}
